<template>
    <div v-if="loadingStep && step" class="flex justify-content-center align-items-center h-10rem">
        <FadeLoader />
    </div>
    <ul v-else class="list-none p-0 m-0 step-details-container">
        <li class="py-3 px-2 surface-border">
            <div class="font-bold w-full font-medium">LABEL</div>
            <!-- Edit mode for step label -->
            <div v-if="editLabel && step">
                <div class="flex flex-column">
                    <InputText maxlength = "255" id="label" :class="{ 'p-invalid': submitted && !step.label }" v-model="step.label" placeholder="Input a label for step" />
                    <small id="labelError" class="p-invalid" v-if="submitted && !step.label">Step label is required.</small>
                </div>
                <Button icon="pi pi-check" class="p-button-rounded mr-2 mb-2" @click="updateLabel" />
            </div>
            <!-- Edit mode for step label ends -->
            <div v-else class="text-900 w-full md:flex-order-0 flex-order-1" @dblclick="editLabel = true">{{ step?.label }}</div>
        </li>
        <li class="py-3 px-2 border-top-1 surface-border">
            <div class="font-bold w-full font-medium">DESCRIPTION</div>
            <!-- Edit mode for step description -->
            <div v-if="editDescription && step">
                <div class="flex flex-column">
                    <Textarea id="description" rows="4" v-model="step.description" placeholder="Enter step description" />
                </div>
                <Button icon="pi pi-check" class="p-button-rounded mr-2 mb-2" @click="updateDescription" />
            </div>
            <!-- Edit mode for step description ends -->
            <div v-else class="text-900 w-full md:flex-order-0 flex-order-1" @dblclick="editDescription = true">{{ step?.description }}...</div>
        </li>
        <li class="border-top-1 surface-border">
            <!-- ordered step links -->
            <ordered-step-links v-if="step" :stepId="step.id" />
        </li>

        <!-- Edit mode for step before text start -->
        <li class="py-3 px-2 border-top-1 surface-border">
            <div class="font-bold w-full font-medium">BEFORE TEXT</div>
            <div v-if="editTextBefore && step">
                <div class="flex flex-column">
                    <Textarea id="description" rows="4" v-model="step.before_text" placeholder="Enter step before text" />
                </div>
                <Button icon="pi pi-check" class="p-button-rounded mr-2 mb-2" @click="updateTextBefore" />
            </div>
            <div v-else class="text-900 w-full md:flex-order-0 flex-order-1" @dblclick="editTextBefore = true">{{ step?.before_text }}...</div>
        </li>
        <!-- Edit mode for step before text ends -->

        <!-- Edit mode for step before text start -->
        <li class="py-3 px-2 border-top-1 surface-border">
            <div class="font-bold w-full font-medium">AFTER TEXT</div>
            <div v-if="editTextAfter && step">
                <div class="flex flex-column">
                    <Textarea id="description" rows="4" v-model="step.after_text" placeholder="Enter step before text" />
                </div>
                <Button icon="pi pi-check" class="p-button-rounded mr-2 mb-2" @click="updateTextAfter" />
            </div>
            <div v-else class="text-900 w-full md:flex-order-0 flex-order-1" @dblclick="editTextAfter = true">{{ step?.after_text }}...</div>
        </li>
        <!-- Edit mode for step before text ends -->
    </ul>
</template>

<script setup>

import { ref, computed, inject } from 'vue';
import { storeToRefs } from 'pinia';
import OrderedStepLinks from '@/products/pha/modules/assessment/modules/link/components/OrderedStepLinks.vue';

const stepStore = inject('stepStore');
const { loadingStep } = storeToRefs(stepStore);

const editLabel = ref(false);
const editDescription = ref(false);
const editTextBefore = ref(false);
const editTextAfter = ref(false);
const submitted = ref(false);

const step = computed(() => {
    return stepStore.activeStep;
});

const updateLabel = async () => {
    const updated = await updateStep();
    // if updated successfully then the editLabel will be changed, else it will stay for further edit
    updated ? (editLabel.value = false) : true;
};

const updateDescription = async () => {
    const updated = await updateStep();
    // if updated successfully then the editLabel will be changed, else it will stay for further edit
    updated ? (editDescription.value = false) : true;
};

const updateTextBefore = async () => {
    const updated = await updateStep();
    // if updated successfully then the editLabel will be changed, else it will stay for further edit
    updated ? (editTextBefore.value = false) : true;
};

const updateTextAfter = async () => {
    const updated = await updateStep();
    // if updated successfully then the editLabel will be changed, else it will stay for further edit
    updated ? (editTextAfter.value = false) : true;
};

const updateStep = async () => {
    submitted.value = true;
    return await stepStore.updateStep(stepStore.activeStep, stepStore.activeStep.id);
};
</script>

<style lang="scss">
.step-details-container {
    height: 60vh !important;
    overflow-y: auto;
}
</style>
